export const RES_AUTH_TOKEN = 'RES_AUTH_TOKEN';
export const BE_BUILD_DATE = 'BE_BUILD_DATE';
export const BE_BUILD_VERSION = 'BE_BUILD_VERSION';
export const RES_AUTH_USER_BACKUP = 'RES_AUTH_USER_BACKUP';
export const RES_AUTH_TOKEN_BACKUP = 'RES_AUTH_TOKEN_BACKUP';
export const RES_IS_DOUBLE_LOGIN = 'RES_IS_DOUBLE_LOGIN';
export const LOCAL_USER = 'USER';

export const APPT_STATUS = {
  BOOKED: 0x1 << 0, // 1
  ARRIVED: 0x1 << 1, // 2
  CONFIRMED: 0x1 << 2, // 4
  PENDING_TICKET: 0x1 << 3, // 8
  PURCHASED: 0x1 << 4, // 16
  CANCELLED: 0x1 << 5, // 32
  NEW_CUSTOMER: 0x1 << 6, // 64
  UNAVAILABLE: 0x1 << 7, // 128
  NO_SHOW: 0x1 << 8 // 256
};

export const HBOT_CALLBACK = 'hbot';
export const IV_CALLBACK = 'iv_cocktail';
export const IV_HIGH_DOSE_CALLBACK = 'iv_high_dose';
export const IV_INGREDIENT_CALLBACK = 'iv_ingredient';
export const MEMBERSHIP_CALLBACK = 'membership';
export const PROMO_CALLBACK = 'promo';

export const MEMBERSHIP_PC_ID = 110;
export const COCKTAIL_PC_ID = 211;
export const INGREDIENT_PC_ID = 280;

export const phoneREX = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const emailREX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const APP_ID = 'POW_FRONTEND';
